import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loyalty-management',
  templateUrl: './loyalty-management.component.html',
  styleUrls: ['./loyalty-management.component.scss']
})
export class LoyaltyManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/loyalty-management/loyalty-management.component.ts